import { Component, OnInit } from '@angular/core';
import { AgentQuestionHandlerComponent } from './agent-question.handler';
import { AgentService } from '../services/agent.service';

@Component({
  selector: 'sym-agent-question',
  templateUrl: './agent-question.component.html',
  styleUrls: ['./agent-question.component.scss'],
})
export class AgentQuestionComponent extends AgentQuestionHandlerComponent {
  constructor(agentService: AgentService) {
    super(agentService);
  }
}
